<template><div id="app"><router-view/></div></template><script>export default {
  name: 'App'
}

</script>

<style>
html,body{
  background: #E7E7E7;
}
#app {
    color: #333;
    /* font-family: 'Microsoft YaHei',Arial, Helvetica, sans-serif; */
    font:14px/1.571429 "Segoe UI","Lucida Grande",Helvetica,Arial,"Microsoft YaHei","FreeSans,Arimo","Droid Sans","wenquanyi micro hei",
    "Hiragino Sans GB","Hiragino Sans GB W3","Roboto",Arial,sans-serif;
  -moz-osx-font-smoothing: grayscale;
    margin: 0;
    width: 100%;
    max-width: 100%;
    min-width: 320px;
    min-height: 100%;
    height: auto;
  font-size: 14px;
  line-height: 1.57;
  color: #333333;
}
.w_container{
  max-width: 1300px;
  margin: 0 auto;
}
.fcolor{
color: #ded9d9;
}
.w_com_bg{
     background-color: #fff;
    /* min-height: 2000px; */
}
.pad10{
  padding: 10px;
}
a{
  color: rgb(255, 255, 255);
}
.w_mar{
  max-width: 1200px;
    margin: 0 auto;
  
}
#app img{
  border: none;
}
.fr{
  float: right;
}
.fl{
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue